import { gql } from '@lcs/shared/api';

export const getCallDetailsReadOnlyQuery = gql`
   query GetCallDetailsReadOnly($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      callDetailReadOnliesConnection(
         first: $first
         filters: $filters
         after: $after
         orderingOptions: $orderingOptions
      ) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            account {
               accountId
               name
            }
            providerId
            sourceProviderId
            destinationProviderId
            callDetailId
            serverName
            callerChannelId
            sipCallId
            sourceExtension {
               extensionId
               number
               name
            }
            startTime
            endTime
            callRecording {
               callRecordingId
               file {
                  fileId
               }
            }
            destinationExtension {
               extensionId
               number
               name
            }
            callDirectionTypeId
            startTime
            sourceExtensionId
            sourceNumber
            destinationExtensionId
            destinationNumber
            originalDestinationNumber
            phoneNumber {
               phoneNumberId
               phoneNumber
            }
            callerName
            callDispositionTypeId
            callRate
         }
      }
   }
`;

export const getCallDetailsQuery = gql`
   query GetCallDetails($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      callDetailsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            account {
               accountId
               name
            }
            providerId
            sourceProviderId
            destinationProviderId
            callDetailId
            serverName
            callerChannelId
            sipCallId
            sourceExtension {
               extensionId
               number
               name
            }
            startTime
            endTime
            callRecording {
               callRecordingId
               file {
                  fileId
               }
            }
            destinationExtension {
               extensionId
               number
               name
            }
            callDirectionTypeId
            startTime
            sourceExtensionId
            sourceNumber
            destinationExtensionId
            destinationNumber
            originalDestinationNumber
            phoneNumber {
               phoneNumberId
               phoneNumber
            }
            callerName
            callDispositionTypeId
            callRate
         }
      }
   }
`;
